var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  xmlSpace: "preserve"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  clipRule: "evenodd",
  fill: "none",
  stroke: "#AAA",
  strokeWidth: 1.32,
  strokeMiterlimit: 10,
  cx: 7.75,
  cy: 7.75,
  r: 7
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  fill: "none",
  stroke: "#AAA",
  strokeWidth: 1.32,
  strokeMiterlimit: 10,
  d: "M19.463 19.463 12.7 12.7"
})));
export default SvgIconSearch;